export class GisAlert {
    mapLayerUrl: string;
    layerName: string;
    systemCheck: SystemCheckDefinition;
    attributes: any;
    constructor(mapLayerUrl: string, layerName: string, systemCheck: SystemCheckDefinition, attributes: any = {}) {
        this.mapLayerUrl = mapLayerUrl;
        this.layerName = layerName;
        this.systemCheck = systemCheck;
        this.attributes = attributes;
    }
}

export class SystemCheckDefinition {
    alertName: string = "";
    // string for now until Category is implemented on the GIS server
    alertCategory = "";//SystemCheckEnum.Unknown;
    buffer = 0;
    bufferMeasurement ="";
    alertText: string;
    systemCheckType: SystemCheckType;
    query: string = "";

    constructor(alertName, alertCategory, buffer, alertText, systemCheckType = SystemCheckType.Basic, query = "", bufferMeasurement = "") {
        this.alertName = alertName;
        this.alertCategory = alertCategory;
        this.buffer = buffer;
        this.alertText = alertText;
        this.systemCheckType = systemCheckType;
        this.query = query;
        this.bufferMeasurement = bufferMeasurement;
    }
}

export enum SystemCheckType  {
    Basic = 0,
    Advanced = 1
};




export enum SystemCheck {
    Unknown = -1,
    ShallowSurfaceCasing = 0,
    UndergroundMine = 1,
    UndergroundAbandonedMines = 2,
    NonMappableUSDW = 3
};


